module.exports = VueAwesomeSwiper;